/* eslint-disable max-lines */
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import ListItemComponent, {
  IStateListItem,
} from 'components/Abstract/ListItem';
import { dateFormat } from 'formatters/date';
import {
  getStatusLabel,
  IFile,
  statuses,
  statusFilters,
} from 'interfaces/file';
import { IUserToken } from 'interfaces/userToken';
import moment from 'moment';
import * as React from 'react';
import { getFileExpirationDate, getFileExpirationTime } from 'helpers/file';

interface IState extends IStateListItem {
  deleted?: boolean;
  openNoticeDialog: boolean;
  nextStatus?: statuses;
}

interface IProps {
  file: any;
  user: IUserToken;
}

export default class ListItem extends ListItemComponent<IProps, IState> {
  readonly firstCellStyle: { wordBreak: 'break-word' };

  constructor(props: IProps) {
    super(props);
    this.state = {
      ...this.state,
      openNoticeDialog: false,
    };
  }

  render(): JSX.Element {
    const { deleted } = this.state;
    const { file } = this.props;
    if (deleted) return null;

    return (
      <TableRow>
        <TableCell
          scope="col"
          style={{
            maxWidth: 350,
            width: 350,
            overflow: 'hidden',
            overflowWrap: 'break-word',
          }}
        >
          {file.tab.name}
        </TableCell>
        <TableCell
          scope="col"
          style={{
            maxWidth: 350,
            width: 350,
            overflow: 'hidden',
            overflowWrap: 'break-word',
          }}
        >
          <a target="_blank" rel="noopener noreferrer" href={file.url}>
            {file.filename}
          </a>
        </TableCell>
        {/* <TableCell>
          {file.emissionDate ? dateFormat(new Date(file.emissionDate)) : '-'}
        </TableCell> */}
        <TableCell>{getFileExpirationDate(file)}</TableCell>
        <TableCell
          style={
            computeTime(file) && computeTime(file) <= 60
              ? { color: '#C01F3D', fontWeight: 'bold' }
              : { color: '#000000DE' }
          }
        >
          {getFileExpirationTime(file)}
        </TableCell>
        <TableCell>{file.frequency}</TableCell>
        <TableCell>{getSituation(file)}</TableCell>
        <TableCell>
          {file.uploadDate ? dateFormat(new Date(file.uploadDate)) : '-'}
        </TableCell>
        <TableCell>
          {file.validationDate
            ? dateFormat(new Date(file.validationDate))
            : '-'}
        </TableCell>
        <TableCell>{file.criticality}</TableCell>
      </TableRow>
    );
  }
}

export const getSituation = (file: IFile) => {
  const statusObj = statusFilters.find((filter) =>
    filter.statuses.some((s) => s.toString() === file.status)
  );

  if (statusObj) {
    return (
      <>
        {file.notice ? (
          <Tooltip
            style={{ fontSize: '12px' }}
            title={`${getStatusLabel(file.status, undefined, file.invalid)} - ${
              file.notice
            }`}
            interactive
          >
            <statusObj.icon />
          </Tooltip>
        ) : (
          <Tooltip
            title={getStatusLabel(file.status, undefined, file.invalid)}
            interactive
          >
            <statusObj.icon />
          </Tooltip>
        )}
      </>
    );
  } else {
    return '-';
  }
};

export const computeTime = (file: IFile) => {
  if (!file.expirationDate) return null;
  const dateDiff = moment(file.expirationDate).diff(moment());
  const duration = moment.duration(dateDiff);
  const asDays = duration.asDays();
  return asDays;
};
